/**
 * Created by Jie Gao on 24/09/18.
 */
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class BonusBunniesGameMode extends GameMode {
    public static readonly STICKY_RESPIN:string = "RANDOM_STICKYRESPIN";
    public static readonly BONUS_GAME:string = "BONUS_GAME";
}